export * from '@/components/organisms/search-bar/tertiary/search-bar';
